<div cdk-overlay-origin
     #connectedOverlayOrigin="cdkOverlayOrigin">
  <div class="td-wb-dropdown-toggle"
       [class.td-wb-dropdown-toggle--chip]="type() === 'chip'"
       [class.td-wb-dropdown-toggle--compact]="size() === 'compact'"
       [class.td-wb-dropdown-toggle--white]="background() === 'white'"
       [class.td-wb-dropdown-toggle--grey]="background() === 'grey'"
       [class.td-wb-dropdown-toggle--selected]="hasSelection()"
       [class.td-wb-dropdown-toggle--outline]="background() === 'outline'"
       [class.td-wb-dropdown-toggle--active]="isOpen()"
       [class.td-wb-dropdown-toggle--panel-top]="panelPosition() === 'top'">
    <div class="td-wb-dropdown-toggle__data"
         [class.td-wb-dropdown-toggle__data--hidden]="isToggleHidden()">
      <!-- MODEL VALUE NOT DEFINED: SHOWS PLACEHOLDER STRING OR CUSTOM PLACEHOLDER -->
      @if (isEmpty()) {
        @if (customPlaceHolder() === undefined) {
          <span class="td-wb-dropdown-toggle__placeholder"
                [attr.aria-hidden]="ariaLabel() === undefined"
                [textContent]="placeholder() || '\u00A0'"></span>
        }
        @if (customPlaceHolder() !== undefined) {
          <ng-content select="td-wb-dropdown-placeholder" />
        }
      }

      <!-- MODEL VALUE IS DEFINED: SHOW VALUE OR CUSTOM TOGGLE -->
      @if (!isEmpty()) {

        @if (customToggle() === undefined) {
          <span
            [textContent]="getSelectedItem()?.getLabel()">
          </span>
        }
        @if (customToggle() !== undefined) {
          <ng-content select="td-wb-dropdown-toggle" />
        }
      }
    </div>
    <!-- ARROW OPEN/CLOSE -->
    <div class="td-wb-dropdown-toggle__caret"
         [class.td-wb-dropdown-toggle__caret--expanded]="isOpen()">
      <td-wb-icon iconId="caret--down"
                  [size]="type() === 'chip' ? '20' : '13'" />
    </div>
  </div>
</div>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayHasBackdrop
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayOrigin]="connectedOverlayOrigin"
  [cdkConnectedOverlayMinWidth]="toggleRect()?.width"
  [cdkConnectedOverlayPositions]="preferredPositions()"
  [cdkConnectedOverlayGrowAfterOpen]="true"
  [cdkConnectedOverlayLockPosition]="false"
  (positionChange)="onPositionChange($event)"
  (backdropClick)="close()"
  (attach)="onAttached()">
  <div #panel
       id="td-wb-dropdown__panel"
       role="listbox"
       [attr.aria-labelledby]="ariaLabelledBy()"
       tabindex="-1"
       [class]="'td-wb-dropdown__panel td-wb-dropdown__panel--' + panelPosition()"
       [style.max-height.px]="panelMaxHeight()"
       (keydown)="onKeyDown($event)">
    <ng-content />
    @if (platformIOS) {
      <button class="td-wb-vh"
              (click)="close()"
              translate="tdWb.dropdown.CLOSE_ARIA">
        <td-wb-icon iconId="cross" />
      </button>
    }
  </div>
</ng-template>

